import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'alt_results';
export const route = 'alt_results/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "alt_results" */
/* webpackPrefetch: true */
'../components/AltResultsPage')));